module.exports = __webpack_public_path__ + "static/media/icon-support-1.264b711c.svg";